import { View } from "@react-pdf/renderer";
import { PDFStyleConfigs } from "../../../configs";

export type PDFTableRowType =
  | "SingleLine"
  | "DoubleLine"
  | "TripleLine"
  | "Quadruple"
  | "HeaderLine"
  | "HeaderLineWithRecommendation"
  | "HeaderSingleLine"
  | "HeaderDoubleLine"
  | "HeaderDoubleLineNoLogo"
  | "HeaderDoubleLineNoLogoWithRecommendation"
  | "HeaderTripleLineNoLogo"
  | "HeaderQuadrupleLineNoLogo"
  | "HeaderQuintupleLineNoLogo"
  | "HeaderSextupleLineNoLogo"
  | "CommentLine"
  | "FeatureIncludeLine"
  | "AppendixCommentTableHeaderHeight"
  | "CommentTableHeaderHeight";

export const PDFTableRow = ({
  children,
  type,
  color = "white",
  rowKey,
  forceShowBorderBottom = false,
  additionHeight = 0,
}: {
  children: React.ReactNode;
  type?: PDFTableRowType;
  color?: "white" | "gray" | "dark" | "primary";
  rowKey?: string | number;
  forceShowBorderBottom?: boolean;
  additionHeight?: number;
}) => {
  const rowHeightMapping = {
    SingleLine: PDFStyleConfigs.TableRowSingleLine,
    DoubleLine: PDFStyleConfigs.TableRowMultipleLine,
    TripleLine: PDFStyleConfigs.TableRowTripleLine,
    Quadruple: PDFStyleConfigs.TableRowQuadrupleLine,
    HeaderLine: PDFStyleConfigs.TableRowHeaderLine,
    HeaderLineWithRecommendation:
      PDFStyleConfigs.TableRowHeaderLineWithRecommendation,
    HeaderDoubleLine: PDFStyleConfigs.TableRowHeaderDoubleLine,
    HeaderDoubleLineNoLogo: PDFStyleConfigs.TableRowHeaderDoubleLineNoLogo,
    HeaderDoubleLineNoLogoWithRecommendation:
      PDFStyleConfigs.TableRowHeaderDoubleLineNoLogoWithRecommendation,
    HeaderTripleLineNoLogo: PDFStyleConfigs.TableRowHeaderTripleLineNoLogo,
    HeaderQuadrupleLineNoLogo:
      PDFStyleConfigs.TableRowHeaderQuadrupleLineNoLogo,
    HeaderQuintupleLineNoLogo:
      PDFStyleConfigs.TableRowHeaderQuinTupleLineNoLogo,
    HeaderSextupleLineNoLogo: PDFStyleConfigs.TableRowHeaderSextupleLineNoLogo,
    HeaderSingleLine: PDFStyleConfigs.TableRowHeaderSingleLine,
    CommentLine: PDFStyleConfigs.TableRowCommentLine,
    FeatureIncludeLine: PDFStyleConfigs.TableRowFeatureIncludeLine,
    AppendixCommentTableHeaderHeight:
      PDFStyleConfigs.AppendixCommentTableHeaderHeight,
    CommentTableHeaderHeight: PDFStyleConfigs.CommentTableHeaderHeight,
  };

  const colorMapping = {
    white: "#FFFFFF",
    gray: "#e0e2e5",
    dark: "#b1b6bf",
    primary: "#515B6F",
  };

  return (
    <View
      key={rowKey}
      style={{
        flexDirection: "row",
        height: type ? rowHeightMapping[type] + additionHeight : "auto",
        minHeight: type ? rowHeightMapping[type] + additionHeight : "auto",
        borderColor: "#7C8493",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth:
          type === "HeaderLine" ||
          type === "HeaderSingleLine" ||
          type === "HeaderLineWithRecommendation" ||
          forceShowBorderBottom
            ? 1
            : 0,
        backgroundColor: color ? colorMapping[color] : "transparent",
      }}
    >
      {children}
    </View>
  );
};
